import axios from "axios";
import { BASE_URL } from "../helper/base-url";

let cachedEnabled = null;
let inflight = null;

/** CAPTCHA is controlled by backend CAPTCHA_ENABLED env only. */
export async function fetchCaptchaEnabled() {
  if (cachedEnabled !== null) return cachedEnabled;
  if (!inflight) {
    inflight = axios
      .get(`${BASE_URL}captcha-config`)
      .then((res) => {
        cachedEnabled = Boolean(res?.data?.enabled);
        return cachedEnabled;
      })
      .catch(() => {
        cachedEnabled = false;
        return false;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** @deprecated Use fetchCaptchaEnabled() — kept for legacy imports during transition. */
export function isCaptchaEnabled() {
  return cachedEnabled === true;
}
